export default __webpack_public_path__ + "static/media/C0004.06cb18bc.png";